var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.newData),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.name || ''))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }